import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const PorcentajeParticipacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('activofijo-button-nuevodetalle', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='% PARTICIPACION' htmlFor='input-porcentajeParticipacion' md={12} />
      <Col md={12}>
        <Field name='porcentajeParticipacion'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              min={0}
              max={100}
              id='input-porcentajeParticipacion'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeParticipacionFormGroup)
